import React, { useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import { Redirect } from "react-router"
import EventBus from "../../../common/EventBus"
import SideBar from "../../../common/layout/sidebar.component"
import { BundleFormAttributes } from "../../../common/types/bundle"
import { ACTION_SUCCESS } from "../../../state/actionlog/ActionLog"
import { getAction } from "../../../state/actionlog/actionLogSelector"
import { createProductAction } from "../../../state/product/ProductActions"
import { PRODUCT_BUNDLE_ACTION_ID } from "../../../utils/bundle/constants"
import BundleForm from "../forms/BundleForm"

const CreateBundleComponent = () => {
    const dispatch = useDispatch()
    const [currentAction, setCurrentAction] = useState(Date.now())
    const actionCreate = useSelector(state => getAction(state, `${PRODUCT_BUNDLE_ACTION_ID.CREATE}-${currentAction}`))

    useEffect(() => {
        SideBar.activateMenu("product")
    }, [])

    const create = (form: BundleFormAttributes) => {
        const dateOfAction = Date.now()
        setCurrentAction(dateOfAction)
        dispatch(createProductAction(`${PRODUCT_BUNDLE_ACTION_ID.CREATE}-${dateOfAction}`, form))
    }

    if (actionCreate && actionCreate.status == ACTION_SUCCESS) {
        EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
            message: (
                <FormattedMessage
                    id="product.bundle.create_bundle_component.bundle_create_notification"
                    defaultMessage="The bundle was created successfully"
                />
            )
        })

        return <Redirect to="/bundles" />
    }

    return (
        <div className="mb-4">
            <BundleForm
                upsertCallback={create}
                error={actionCreate.error}
            />
        </div>
    )

}

export default CreateBundleComponent


// WEBPACK FOOTER //
// ./src/product/bundle/components/CreateBundleComponent.tsx